import { MapContainer, TileLayer, CircleMarker, Popup, Polyline } from "react-leaflet";
import "leaflet/dist/leaflet.css";

export default function MapView({
  center = [20, 0],
  zoom = 2,
  markers = [],
  lines = [],
  origin = null,
  height = "500px",
}) {
  return (
    <div style={{ height }} className="border border-zinc-300 bg-white overflow-hidden" data-testid="map-view">
      <MapContainer center={center} zoom={zoom} scrollWheelZoom worldCopyJump
        style={{ height: "100%", width: "100%" }}>
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; OpenStreetMap &copy; CARTO'
        />
        {lines.map((l, i) => (
          <Polyline key={i} positions={[l.from, l.to]}
            pathOptions={l.style || { color: "#0047FF", weight: 0.7, opacity: 0.35 }} />
        ))}
        {origin && (
          <CircleMarker center={origin.center} radius={7}
            pathOptions={{ color: "#FF2B2B", fillColor: "#FF2B2B", fillOpacity: 1, weight: 2 }}>
            {origin.label && <Popup>{origin.label}</Popup>}
          </CircleMarker>
        )}
        {markers.map((m, i) => (
          <CircleMarker key={i} center={[m.lat, m.lon]} radius={m.radius || 4}
            pathOptions={{ color: m.color || "#0047FF", fillColor: m.color || "#0047FF", fillOpacity: 0.75, weight: 1 }}>
            {m.popup && <Popup>{m.popup}</Popup>}
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
